module.exports = __webpack_public_path__ + "img/ic_save.d830e223.svg";